import React from "react";
import { Box, Snackbar, Alert, Button } from "@mui/material";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { useNotificationContext } from "../context/NotificationContext";
import { BoxCentered } from "./DVCFilter/Styles";

const DashLayout = () => {

    const { snackbarMessage, setSnackbarMessage, snackbarType, setTargetTabValue, setConnectionTarget, moduleAwaitingAuditResult,    isFromGMP, isFromDataAudit, runInstanceIdDataAudit, runInstanceIdGMP } =
    useNotificationContext();
   const navigate = useNavigate();

  const handleClose = () => setSnackbarMessage(null);
  const location = useLocation();
  
  return (
    <Box
      sx={{
       backgroundColor: "#E9EDEC ",
        height: "100%",
        width: "100%",
      }}
    >
      <Outlet />

     <Snackbar 
  open={!!snackbarMessage}
  autoHideDuration={4000}
  onClose={handleClose}
  anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
>
  <Alert onClose={handleClose} severity={snackbarType || "success"} sx={{ width: "100%" }}>
    <BoxCentered>
      {snackbarMessage}{" "}
    </BoxCentered>
    {snackbarType === "error" ? null : (
      snackbarType === "success" &&
      (isFromDataAudit || isFromGMP) &&
      (
        snackbarMessage !== "Your report is ready to download" ||
        (
          isFromDataAudit &&
          location.pathname !== `/private/data-audit/${encodeURIComponent(moduleAwaitingAuditResult)}`
        )
      ) && (
        <Button
          style={{ color: "inherit", textDecoration: "underline", marginLeft: 8 }}
          onClick={() => {
            if (isFromGMP) {
              navigate(`/private/gmp/GMP%20Equalisation`);
              setTargetTabValue(4);
            } else {
              navigate(`/private/data-audit/${encodeURIComponent(moduleAwaitingAuditResult)}`);
              moduleAwaitingAuditResult === "Custom Data Audit"
                ? setTargetTabValue(6)
                : setTargetTabValue(3);
            }
            handleClose();
            setConnectionTarget("Connection");
          }}
        >
          {isFromGMP ? "View Readiness Results" : "View Data Audit Results"}
        </Button>
      )
    )}
  </Alert>
</Snackbar>

    </Box>
  );
};

export default DashLayout;
